import { Button, Pending, sharpDateFormatter } from '@finbeat/react-toolkit';
import {
    LIMIT_STATE_APPROVED,
    LIMIT_STATE_DECLINED,
    LIMIT_STATE_DECLINED_SCORE,
    LIMIT_STATE_RESET_REQUIRED,
} from 'constans/limitStates';
import { useGeneralSettingsContext } from 'providers/GeneralSettingsProvider';
import { useMerchantOrderContext } from 'providers/MerchantOrderProvider';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, Col, Row } from 'reactstrap';

const MerchantOrderCreditLimit = () => {
    const { dateFormat } = useGeneralSettingsContext();
    const { t } = useTranslation();
    const {
        clientCreditLimit,
        clientLimitFetching,
        waitClientLimitResponse,
        requestClientLimitLoading,
        requestClientLimitMutate,
    } = useMerchantOrderContext();

    return (
        <Card className="border-info mb-3">
            <CardBody>
                <Row className="align-items-center">
                    {!clientLimitFetching && !waitClientLimitResponse && (
                        <>
                            <Col>
                                <p>
                                    {t('BackOfficeClientStatus')}:
                                    {' ' +
                                        t(
                                            `BackOfficeClientLimitStates${clientCreditLimit.limitState}`
                                        )}
                                </p>
                                {clientCreditLimit.limitState === LIMIT_STATE_APPROVED && (
                                    <p>
                                        {t('BackOfficeLimitApproved')}: {clientCreditLimit.amount}
                                    </p>
                                )}
                                {clientCreditLimit.limitState === LIMIT_STATE_DECLINED_SCORE && (
                                    <>
                                        <p>
                                            {t('BackOfficeAmountRequest')}:{' '}
                                            {clientCreditLimit.amountRequest}
                                        </p>
                                        <p>
                                            {t('BackOfficeScoreLimit')}: {clientCreditLimit.amount}
                                        </p>
                                    </>
                                )}
                                {[
                                    LIMIT_STATE_RESET_REQUIRED,
                                    LIMIT_STATE_APPROVED,
                                    LIMIT_STATE_DECLINED_SCORE,
                                ].indexOf(clientCreditLimit.limitState) > -1 && (
                                    <p>
                                        {t('BackOfficeLimitTerm')}:{' '}
                                        {sharpDateFormatter(clientCreditLimit.term, dateFormat)}
                                    </p>
                                )}
                                {clientCreditLimit.limitState === LIMIT_STATE_DECLINED && (
                                    <p className="text-danger">
                                        {t('BackOfficeLimitResetTerm')}{' '}
                                        {sharpDateFormatter(
                                            clientCreditLimit.blockTerm,
                                            dateFormat
                                        )}
                                    </p>
                                )}
                            </Col>
                            {clientCreditLimit.limitState === LIMIT_STATE_RESET_REQUIRED && (
                                <Col sm={4}>
                                    <Button
                                        disabled={requestClientLimitLoading}
                                        onClick={() => requestClientLimitMutate()}
                                    >
                                        {t('BackOfficeLimitReset')}
                                    </Button>
                                </Col>
                            )}
                        </>
                    )}
                    {(clientLimitFetching || waitClientLimitResponse) && <Pending />}
                </Row>
            </CardBody>
        </Card>
    );
};

export default MerchantOrderCreditLimit;
